


<template>
  <div>
    <div class="centered-child" style="padding-bottom: 16px">
      <div style="padding-top: 16px"><h2>Choose your means of payment</h2></div>

      <div style="width: 100%">
        <p style="font-size: 16px; padding-bottom: 16px">
          You need to pay before making your appeal</p>
      </div>

      <md-card class="light-frame" style="width: 100%">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">With MasterCard, VISA, AMEX</div>
            <div class="md-subhead">
              You need to have a payment card like MasterCard, VISA ou AMEX.<br>
              <br>
              You will receive your appeal within the next 48 hours.
            </div>

            <!-- <div class="md-title" style="color:red"> Promo Code: VISASUMMER </div>
             <div class="md-subhead"style="color:red">
              Your visa application file at 49€ and your appeal at 99€.
            </div> -->
          </md-card-header-text>

          <md-card-media>
                <img src="/static/credit-card.svg" style="max-width: 240px;">
          </md-card-media>
        </md-card-header>

        <md-card-media style="padding: 16px; display: flex; justify-content: center; ">
          <md-button class="md-raised md-primary large-button"
            @click="onClick('stripe')">Choose</md-button>
        </md-card-media>
      </md-card>

      <md-card class="light-frame" style="width: 100%">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Ask a friend to pay for you</div>
            <div class="md-subhead">
             You know someone whocan pay for you witha payment card like MasterCard, VISA ou AMEX.<br>
              <br>
             You will receive your appeal within the next 48 hours.
            </div>
            
            <!-- <div class="md-title" style="color:red"> Promo Code: VISASUMMER </div>
             <div class="md-subhead"style="color:red">
              Your visa application file at 49€ and your appeal at 99€.
            </div> -->
          </md-card-header-text>

          <md-card-media>
                <img src="/static/credit-card2.svg" style="max-width: 240px;">
          </md-card-media>
        </md-card-header>

        <md-card-media style="padding: 16px; display: flex; justify-content: center; ">
          <md-button class="md-raised md-primary large-button"
            @click="onClick('stripe-friend')">Choose</md-button>
        </md-card-media>
      </md-card>



      <!-- <md-card class="light-frame" style="width: 100%">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Pay by International Express Money Order </div>
            <div class="md-subhead">
              The international Express Money Order has to be done with cash at your closest post office.<br>
              <br>
              The payment may need <b>48h</b> before coming on our bank account. Your appeal will be made once we receive the payment.
              </div>
          </md-card-header-text>

          <md-card-media>
                <img src="/static/mandatexpress.svg" style="max-width: 240px;">
          </md-card-media>
        </md-card-header>

        <md-card-media style="padding: 16px; display: flex; justify-content: center; ">
          <md-button class="md-raised md-primary large-button"
          @click="onClick('mandat-express')">Choose</md-button>
        </md-card-media>
      </md-card>

      <md-card class="light-frame" style="width: 100%">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">By Western Union transfer</div>
            <div class="md-subhead">
              The Western Union Transfer has to be made by cash in a specialised institute (<a href="https://www.westernunion.com/fr/en/agent-locator.html" target="_blank">look for a specialised institute close to your place</a>).<br>
              <br>
                The payment may need<b>24h</b> before coming on our bank account. Your appeal will be made once we receive the payment.
              </div>
          </md-card-header-text>

          <md-card-media>
                <img src="/static/western-union.svg" style="max-width: 240px;">
          </md-card-media>
        </md-card-header>

        <md-card-media style="padding: 16px; display: flex; justify-content: center; ">
          <md-button class="md-raised md-primary large-button"
          @click="onClick('western-union')">Choose</md-button>
        </md-card-media>
      </md-card>
 -->

      <!--<md-card class="light-frame" style="width: 100%">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Par virement bancaire international</div>
            <div class="md-subhead">
              Vous devez vérifiez avec votre banque si vous être en mesure d'effectuer un virement internationnal vers la zone euro.<br>
              <br>
             Le paiement peut mettre jusqu'à <b>7 à 10 jours</b> avant d'arriver sur nos comptes. Votre recours sera rédigé qu'une fois le paiement validé par nos services.
            </div>
          </md-card-header-text>

          <md-card-media>
                <img src="/static/wiretransfer.svg" style="max-width: 240px;">
          </md-card-media>
        </md-card-header>

        <md-card-media style="padding: 16px; display: flex; justify-content: center; ">
          <md-button class="md-raised md-primary large-button"
          @click="onClick('wire')">Choisir</md-button>
        </md-card-media>
      </md-card>-->

      <!--
      <md-card class="light-frame" style="width: 100%">
          <md-card-header>
            <md-card-header-text>
              <div class="md-title">Paypal</div>
              <div class="md-subhead">
                Vous devez disposer d'un compte Paypal (<a href="https://www.paypal.com/fr/" target="_blank">plus d'information</a>).<br>
                <br>
                Vous obtiendrez votre recours sous 48h.</div>
            </md-card-header-text>

            <md-card-media>
                  <img src="/static/paypal.svg" style="max-width: 240px;">
            </md-card-media>
          </md-card-header>

          <md-card-media style="padding: 16px; display: flex; justify-content: center; ">
            <md-button class="md-raised md-primary large-button"
            @click="onClick('paypal')">Choisir</md-button>
          </md-card-media>
        </md-card>
        -->


    </div>
  </div>
</template>



<script>

import ServiceAccess from '../service/ServiceAccess'


export default {


  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-payment-display')

    window.scrollTo(0, 0)
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      if (this.paymentDone) {
        this.$router.replace('/f/' + this.$route.params.sessionId + '/')
      } else {
        this.$router.back()
      }
    },


    valueUpdated: function (qid, v) {
      this.values[qid] = v
    },

    onClick: function (medium) {
      ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-payment', {kind: medium})
      if (medium === 'stripe' || medium === 'stripe-friend') {
        this.$router.push('/f/' + this.$route.params.sessionId + '/' + medium + '/' + this.$route.params.cart)
      } else {
        this.$router.push('/f/' + this.$route.params.sessionId + '/payment-why/' + medium + '/' + this.$route.params.cart)
      }
    }


  }
}
</script>



// WEBPACK FOOTER //
// CheckoutPayment.vue?61b7a433